import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import Formatter from '../../../../formatter';
import helpers from '../utils/fieldsHelper';
import { FormActionsContext } from '../context/FormContext';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormOptions from '../context/useFormOptions';
import useFormContext from '../context/useFormContext';
import useFormLayout from '../layout/useFormLayout';
import Divider from '@material-ui/core/Divider';
import FormField from './Field';
import FormFieldLabel from '../fields/Label';
import FormFieldSignature from '../fields/Signature';
import FormFieldText from '../fields/Text';
import CurrencyField from '../fields/Currency';
import TextAreaField from '../fields/TextArea';
import FormFieldDate from '../fields/Date';
import Checkbox from '../fields/Checkbox';
import Image from '../fields/Image';
import File from '../fields/File';
import Rating from '../fields/Rating';
import Richtext from '../fields/Richtext';
import ConnectedDropdown from './ConnectedDropdown';
import ConnectedRadioGroup from './ConnectedRadioGroup';
import ConnectedCheckboxGroup from './ConnectedCheckboxGroup';
import ConnectedRepeating from './ConnectedRepeating';
import ConnectedGroup from './ConnectedGroup';
import ConnectedGoogleMapField from './ConnectedGoogleMapField';
import ConnectedGoogleAddressField from './ConnectedGoogleAddressField';
import ConnectedSubscriptionsField from './ConnectedSubscriptionsField';
import ConnectedLoginFields from './ConnectedLoginFields';

var ConnectedFormField = function ConnectedFormField(_ref) {
  var fieldId = _ref.fieldId;
  var options = useFormOptions();
  var layout = useFormLayout();
  var fieldData = useFormDataLayer(fieldId);

  var _React$useContext = React.useContext(FormActionsContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 1),
      actionsState = _React$useContext2[0];

  var _useFormContext = useFormContext(),
      state = _useFormContext.state;

  var context = state.context;

  var _ref2 = context || {},
      userPermissions = _ref2.permissions;

  var value = fieldData.value,
      dispatch = fieldData.dispatch,
      error = fieldData.error,
      type = fieldData.type,
      active = fieldData.active;
  var labelPlacement = fieldData.labelPlacement,
      caption = fieldData.caption,
      required = fieldData.required;
  var description = fieldData.description,
      placeholder = fieldData.placeholder,
      rows = fieldData.rows;
  var maxCharacters = fieldData.maxCharacters,
      min = fieldData.min,
      max = fieldData.max,
      optimize = fieldData.optimize;
  var mask = fieldData.mask,
      format = fieldData.format,
      xpath = fieldData.xpath,
      lookupVisiblity = fieldData.lookupVisiblity,
      onLookup = fieldData.onLookup;
  var futureDatesOnly = fieldData.futureDatesOnly,
      pastDatesOnly = fieldData.pastDatesOnly,
      lowerBound = fieldData.lowerBound,
      upperBound = fieldData.upperBound;
  var dateFormat = fieldData.dateFormat,
      timeFormat = fieldData.timeFormat,
      separator = fieldData.separator;
  var fieldPermissions = fieldData.permissions;
  var disableRepositoryAccess = options.disableRepositoryAccess,
      hideLookupButton = options.hideLookupButton;
  var workspace = options.workspace,
      path = options.path;
  var variant = layout.variant; // use readonly option if no permission granted

  var readonly = fieldData.readonly;
  if (!helpers.hasPermission(userPermissions, fieldPermissions)) readonly = true;

  switch (type) {
    case 'label':
      return React.createElement(FormFieldLabel, {
        caption: caption
      });

    case 'separator':
      return React.createElement(Divider, null);

    case 'login':
      return React.createElement(ConnectedLoginFields, {
        labelPlacement: labelPlacement || 'left',
        fieldId: fieldId,
        value: value,
        error: error,
        variant: variant,
        dispatch: dispatch
      });

    case 'googlemap':
      return React.createElement(ConnectedGoogleMapField, {
        fieldId: fieldId,
        variant: variant,
        xpath: xpath,
        lookupVisiblity: hideLookupButton ? 'hide' : lookupVisiblity
      });

    case 'googleaddress':
      return React.createElement(ConnectedGoogleAddressField, {
        fieldId: fieldId,
        variant: variant,
        xpath: xpath,
        lookupVisiblity: hideLookupButton ? 'hide' : lookupVisiblity
      });

    case 'subscriptions':
      return React.createElement(ConnectedSubscriptionsField, {
        fieldId: fieldId,
        variant: variant
      });

    case 'hyperlink':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left'
      }, React.createElement("div", {
        style: {
          paddingTop: '6px'
        }
      }, React.createElement(Formatter.Link, {
        component: "a" // use default html link component
        ,
        openInNewTab: true,
        value: fieldData.url,
        text: fieldData.displayText || fieldData.url
      })));

    case 'signature':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(FormFieldSignature, Object.assign({
        fieldId: fieldId
      }, fieldData, {
        variant: variant
      })));

    case 'image':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(Image, {
        disableRepositoryAccess: disableRepositoryAccess,
        readonly: readonly,
        folder: path,
        workspace: workspace,
        fieldId: fieldId,
        dispatch: dispatch,
        value: value,
        error: error,
        variant: variant,
        optimize: optimize
      }));

    case 'file':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(File, {
        fieldId: fieldId,
        dispatch: dispatch,
        value: value,
        error: error,
        readonly: readonly,
        description: description,
        placeholder: placeholder,
        extensions: fieldData.extensions,
        browseEOSFiles: fieldData.browseEOSFiles,
        browseLocalFiles: fieldData.browseLocalFiles,
        disableRepositoryAccess: disableRepositoryAccess,
        variant: variant,
        workspace: workspace,
        formPath: path,
        onUploadFile: actionsState.onUploadFile,
        optimize: optimize
      }));

    case 'textarea':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(TextAreaField, {
        active: active,
        fieldId: fieldId,
        value: value,
        xpath: xpath,
        dispatch: dispatch,
        error: error,
        lookupVisiblity: hideLookupButton ? 'hide' : lookupVisiblity,
        description: description,
        maxCharacters: maxCharacters,
        placeholder: placeholder,
        rows: rows,
        readonly: readonly,
        variant: variant
      }));

    case 'date':
    case 'time':
    case 'datetime':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(FormFieldDate, {
        active: active,
        fieldId: fieldId,
        description: description,
        type: type,
        value: value,
        xpath: xpath,
        dispatch: dispatch,
        error: error,
        readonly: readonly,
        lookupVisiblity: hideLookupButton ? 'hide' : lookupVisiblity,
        futureDatesOnly: futureDatesOnly,
        pastDatesOnly: pastDatesOnly,
        upperBound: upperBound,
        lowerBound: lowerBound,
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        separator: separator,
        variant: variant
      }));

    case 'dropdown':
      return React.createElement(ConnectedDropdown, {
        fieldId: fieldId,
        variant: variant
      });

    case 'radiogroup':
      return React.createElement(ConnectedRadioGroup, {
        fieldId: fieldId,
        variant: variant
      });

    case 'checkboxgroup':
      return React.createElement(ConnectedCheckboxGroup, {
        fieldId: fieldId,
        variant: variant
      });

    case 'repeating':
      return React.createElement(ConnectedRepeating, {
        fieldId: fieldId,
        variant: variant
      });

    case 'datagroup':
      return React.createElement(ConnectedGroup, {
        fieldId: fieldId,
        variant: variant
      });

    case 'currency':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(CurrencyField, {
        format: format || '$###0.00 th: dec:.',
        active: active,
        description: description,
        placeholder: placeholder,
        fieldId: fieldId,
        value: value,
        dispatch: dispatch,
        error: error,
        readonly: readonly,
        variant: variant
      }));

    case 'textbox':
    case 'number':
    case 'password':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(FormFieldText, {
        xpath: xpath,
        lookupVisiblity: hideLookupButton ? 'hide' : lookupVisiblity,
        onLookup: onLookup,
        type: type,
        mask: mask,
        format: format,
        active: active,
        description: description,
        placeholder: placeholder,
        fieldId: fieldId,
        value: value,
        maxCharacters: maxCharacters,
        min: min,
        max: max,
        dispatch: dispatch,
        error: error,
        readonly: readonly,
        variant: variant
      }));

    case 'checkbox':
      return React.createElement(Checkbox, {
        fieldId: fieldId,
        value: value,
        caption: caption,
        dispatch: dispatch,
        error: error,
        active: active,
        required: required,
        readonly: readonly,
        variant: variant
      });

    case 'rating':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(Rating, Object.assign({
        fieldId: fieldId
      }, fieldData)));

    case 'richtext':
      return React.createElement(FormField, {
        label: caption,
        labelPlacement: labelPlacement || 'left',
        required: required
      }, React.createElement(Richtext, Object.assign({
        fieldId: fieldId
      }, fieldData)));

    default:
      return React.createElement("div", {
        style: {
          backgroundColor: 'red'
        }
      }, "Unknown field type.");
  }
};

export default React.memo(ConnectedFormField);